import { IPatientDoctorRelation } from '@alberta/konexi-shared';

export class PatientDoctorRelationViewModel implements IPatientDoctorRelation {
  doctorId: string;
  contactId: string;
  _id: string;
  timestamp: Date;
  archived: boolean;
}
